export default __webpack_public_path__ + "static/media/secure.42fea35b.svg";